(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-book-button"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.fetch) return; // No fetch → plain link to the booking app still works.
    var cache = {};
    // Ping the booking app once per URL; resolve true if reachable, false if down/timed out.
    function probe(url) {
      if (!url) return Promise.resolve(true); // No health URL set → always use the app link.
      if (cache[url]) return cache[url];
      var p = new Promise(function (resolve) {
        var ctrl = ('AbortController' in window) ? new AbortController() : null;
        var t = setTimeout(function () { if (ctrl) ctrl.abort(); resolve(false); }, 4000);
        fetch(url, { mode: 'no-cors', cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
          .then(function () { clearTimeout(t); resolve(true); })
          .catch(function () { clearTimeout(t); resolve(false); });
      });
      cache[url] = p;
      return p;
    }
    document.querySelectorAll('[data-vc-book-btn]').forEach(function (b) {
      var fb = b.getAttribute('data-fallback');
      if (!fb) return;
      // Check at load (not click): swap the link before the customer taps it, so there's
      // no delay and no popup-blocker issue from an async window.open.
      probe(b.getAttribute('data-check')).then(function (ok) {
        if (!ok) {
          b.setAttribute('href', fb);
          b.removeAttribute('target'); // route to our own form in the same tab
          b.setAttribute('data-fallback-active', '1');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-shop-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vc-shopgrid').forEach(function (root) {
    // Native sort (collection page): change the sort_by URL param and reload
    var sort = root.querySelector('.vc-shopgrid__sort');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }
    // Client-side type chips (featured placement only)
    var bar = root.querySelector('.vc-shopgrid__filter');
    if (bar) {
      var buttons = bar.querySelectorAll('.vc-filterbtn');
      var cards = root.querySelectorAll('.vc-pcard2');
      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('.vc-filterbtn');
        if (!btn) return;
        var filter = btn.getAttribute('data-filter');
        buttons.forEach(function (b) { var a = b === btn; b.classList.toggle('is-active', a); b.setAttribute('aria-pressed', a ? 'true' : 'false'); });
        cards.forEach(function (c) { c.hidden = !(filter === 'all' || c.getAttribute('data-type') === filter); });
      });
    }
    // Client-side sort for curated/featured grids (all cards present, no pagination)
    var csort = root.querySelector('.vc-shopgrid__csort');
    var grid = root.querySelector('.vc-shopgrid__grid');
    if (csort && grid) {
      var original = Array.prototype.slice.call(grid.querySelectorAll('.vc-pcard2'));
      csort.addEventListener('change', function () {
        var v = csort.value, arr = original.slice();
        if (v === 'price-asc') arr.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
        else if (v === 'price-desc') arr.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
        else if (v === 'title-asc') arr.sort(function (a, b) { return (a.dataset.title || '').localeCompare(b.dataset.title || ''); });
        else if (v === 'title-desc') arr.sort(function (a, b) { return (b.dataset.title || '').localeCompare(a.dataset.title || ''); });
        else if (v === 'date-desc') arr.sort(function (a, b) { return (+b.dataset.date) - (+a.dataset.date); });
        arr.forEach(function (c) { grid.appendChild(c); });
      });
    }
    var ft = root.querySelector('.vc-shopgrid__filtertoggle');
    if (ft) {
      ft.addEventListener('click', function () {
        var open = root.classList.toggle('vc-shopgrid--filters-open');
        ft.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
